<div class="ds-line-chart">
    <div class="ds-line-chart__header">
        <h1>{{title}}</h1>
    </div>
    <div class="ds-line-chart__content">
        <ngx-charts-line-chart
                [results]="data"
                [xAxis]="true" [yAxis]="true"
                [customColors]="colorScheme"
                [view]="view"
                (select)="onSelect($event)"
                (activate)="onActivate($event)"
                (deactivate)="onDeactivate($event)">
        </ngx-charts-line-chart>
    </div>
</div>
